export default "__VITE_ASSET__Bm2glvBo__"